import React from 'react';
import PropTypes from 'prop-types';
import Modal_50_50 from '../../3_Organisms/Modal/Modal_50_50';
import { getLang, formatPrice, getBaseUrl, getFinanceWeekly, getLeaseBiWeeklyFromOptions, pushToGTMDataLayer } from '../../../utils';
import { useTranslation } from "react-i18next";
import { titleCase } from '../../../Helpers/helpers';
import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import GTMHelper from '../../../Helpers/gtmHelper';
import { Tooltip } from '../../1_Atoms/Tooltip/Tooltip';
import ReactHtmlParser from 'react-html-parser';

export const AccessoryCard = ({ Accessory, Selected, HandleSelectedAccessory, HandleLearnMore, isPopular, showFinancePrice, ...props }) => {
	const [modalOpen, setModalOpen] = React.useState(false);
    const { t, i18n } = useTranslation(['accessories', 'general']);
	const gtmHelper = new GTMHelper();

    //const [selected] = React.useState(Selected);
    const financial = JSON.parse(sessionStorage.getItem(Constants.FinancialObj));
    const financeTermIndex = parseInt(sessionStorage.getItem(Constants.FinanceTermIndex));
    const leaseTermIndex = parseInt(sessionStorage.getItem(Constants.LeaseTermIndex));
    const financeTerm = parseInt(sessionStorage.getItem(Constants.FinanceTerm));
    const leaseTerm = parseInt(sessionStorage.getItem(Constants.LeaseTerm));

    function setSelectedAccessory() {
        HandleSelectedAccessory(Accessory.index)
    }

    const imagePath = getBaseUrl() + process.env.REACT_APP_BASIC_CONTENT_PATH;

    function HandleLearnMore() {
        setModalOpen(!modalOpen);
        document.querySelector('html').classList.add('inactive');
		gtmHelper.setGTM({'action':'Open Modal','modal': 'Accessory Learn More'}, true, false);
    }

    function closeModal() {
        setModalOpen(false);
    }

    function getTooltipText(Accessory) {
        const lang = getLang();
        const totalCost = formatPrice(Accessory.price, true);
        const priceIncludesText = lang == 'en' ? 'Includes' : 'Contient';
        const installationText = lang === 'en' ? 'Installation cost' : 'Coûts d\'installation';
        const totalPriceText = lang === 'en' ? 'Total price' : 'Prix totaux';
    
        let text = `${priceIncludesText}:`;
            text += `<br>${Accessory.name}: ${formatPrice(Accessory.base_msrp, true)}`;
            text += Accessory.install_cost ? `<br>${installationText}: ${formatPrice(Accessory.install_cost, true)}` : '';
            text += `<hr>${totalPriceText}:${totalCost}`;
        return text;
    }

    function accessoryTotalCost(){
        return Accessory.price + Accessory.install_cost ? Accessory.price + Accessory.install_cost : 0;
    }

    return (
        <>
        {Accessory ? <>
        <div className={`accessory-card ${Selected?'accessory-card-selected':''}`}>
            <div className="accessory-card__content">
				{Accessory.popular === true && !isPopular ? <p className="accessory-card__popular label">{t("popular")}</p> : null}
                <img className="accessory-card__img" alt={Accessory.name} src={`${imagePath}/accessories/${Accessory.image}`} onClick={() => HandleLearnMore()} />
                <span className={ Selected ? "accessory-card__selected-indicator selected" : "accessory-card__selected-indicator"}><i className="mz-svg mz-svg--white mz-svg-checkmark"></i></span>
                <div className="accessory-card__info">
                    <h3 className="accessory-card__title">{titleCase(Accessory.name)}</h3>
                </div>
				<div className="accessory-card__CTAs">
                    <p className="accessory-card__price">{Accessory.price!==0?`+ ${formatPrice(Accessory.price)}`:''} {Accessory.price_week !== null ? <span>{Accessory.price!==0?
                        `(${showFinancePrice?
                            `${getFinanceWeekly(Accessory.price, financial.calculatedFinance.financeValues[financeTermIndex].aprRate, financial.calculatedFinance.financeValues[financeTermIndex].term)}${t("general:week")}`:
                            `${getLeaseBiWeeklyFromOptions(Accessory.price, financial.calculatedLease.leaseValues[leaseTermIndex].leaseRate, financial.calculatedLease.leaseValues[leaseTermIndex].term)}${t("general:bi_week")}`})`:''}<sup>1</sup><Tooltip TooltipText={ReactHtmlParser(getTooltipText(Accessory))} /></span> : t("with_installation")}
                            
                    </p>
					<button className={Selected ? 'mz-btn mz-btn--primary accessory-card__select-button':'mz-btn mz-btn--primary accessory-card__select-button mz-btn--red'} onClick={() => setSelectedAccessory()}><span>{ Selected ? t("remove"): t("accessories:add_to_build")}</span></button>
					<div className="accessory-card__learn-more-button"> <a className="mz-link label text--grey" onClick={() => HandleLearnMore()}>{t("accessories:learn_more")}</a></div>
				</div>
            </div>
        </div>
        <Modal_50_50 title={Accessory.name} copy={Accessory.description} image={Accessory.image} imageMobile={Accessory.image} imageAlt={Accessory.name} modalId={Accessory.id} isOpen={modalOpen} setIsModalOpen={closeModal} />
        </>: null}</>
    )

}


export default AccessoryCard;

AccessoryCard.propTypes = {
    HandleSelectedAccessory: PropTypes.func,
    HandleLearnMore: PropTypes.func,
}

AccessoryCard.defaultProps = {
    HandleSelectedAccessory: () => { },
    HandleLearnMore: () => { },
};
